var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99935 10.791L5.54102 9.04102V7.29102H8.45768V9.04102L6.99935 10.791Z",
    fill: "#E8BEAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62435 6.12565C9.94652 6.12565 10.2077 5.86448 10.2077 5.54232C10.2077 5.22015 9.94652 4.95898 9.62435 4.95898C9.30218 4.95898 9.04102 5.22015 9.04102 5.54232C9.04102 5.86448 9.30218 6.12565 9.62435 6.12565Z",
    fill: "#E8BEAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37435 6.12565C4.69652 6.12565 4.95768 5.86448 4.95768 5.54232C4.95768 5.22015 4.69652 4.95898 4.37435 4.95898C4.05218 4.95898 3.79102 5.22015 3.79102 5.54232C3.79102 5.86448 4.05218 6.12565 4.37435 6.12565Z",
    fill: "#E8BEAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 3.79093C9.625 1.57427 4.375 2.3326 4.375 3.79093V5.8326C4.375 7.29093 5.54167 8.4576 7 8.4576C8.45833 8.4576 9.625 7.29093 9.625 5.8326V3.79093Z",
    fill: "#E8BEAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 1.16602C5.22148 1.16602 4.08398 2.59518 4.08398 4.37435V5.04518L4.66732 5.54102V4.08268L8.16732 2.91602L9.33398 4.08268V5.54102L9.91732 5.04518V4.37435C9.91732 3.20768 9.62565 2.04102 8.16732 1.74935L7.87565 1.16602H7.00065Z",
    fill: "#131313"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 5.83333C8.32775 5.83333 8.45833 5.70275 8.45833 5.54167C8.45833 5.38058 8.32775 5.25 8.16667 5.25C8.00558 5.25 7.875 5.38058 7.875 5.54167C7.875 5.70275 8.00558 5.83333 8.16667 5.83333Z",
    fill: "#131313"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 5.83333C5.99377 5.83333 6.12435 5.70275 6.12435 5.54167C6.12435 5.38058 5.99377 5.25 5.83268 5.25C5.6716 5.25 5.54102 5.38058 5.54102 5.54167C5.54102 5.70275 5.6716 5.83333 5.83268 5.83333Z",
    fill: "#131313"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45898 9.04102L7.00065 9.33268L5.54232 9.04102C5.54232 9.04102 2.33398 9.62435 2.33398 12.8327H11.6673C11.6673 9.62435 8.45898 9.04102 8.45898 9.04102Z",
    fill: "#F28181"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70768 10.209L6.41602 12.834H7.58268L7.29102 10.209L7.58268 9.91732L6.99935 9.33398L6.41602 9.91732L6.70768 10.209Z",
    fill: "#666DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManager);
export default __webpack_public_path__ + "static/media/Manager.02ac6ca2657c562878715e8891e94ee7.svg";
export { ForwardRef as ReactComponent };